import React, { ReactNode } from 'react';
import isDefined from 'lib/isDefined';

interface ReadOnlyFieldProps {
    label?: ReactNode;
    emptyDisplay?: ReactNode;
    children?: ReactNode;
}

export const ReadOnlyField: React.FC<React.PropsWithChildren<ReadOnlyFieldProps>> = (props) => {
    const {
        label,
        emptyDisplay,
        children,
    } = props;

    let content: ReactNode;

    if (hasChildren(children)) {
        content = children;
    } else if (emptyDisplay !== undefined) {
        content = <i className="text-muted">{emptyDisplay}</i>;
    } else {
        content = '-';
    }

    return (
        <div className="field">
            {label && <label className="field-label">{label}</label>}
            <div className="field-value">{content}</div>
        </div>
    );
}

function hasChildren(children: ReactNode): boolean {
    return Array.isArray(children)
        ? children.some((node) => hasChildren(node))
        : children !== false && children !== '' && isDefined(children);
}

export default ReadOnlyField;